import MaterialIcon from "../../components/BuilderComponents/MaterialIcon";

const ProfilePopover = ({ user, onChangePassword, onLogout }) => {
  const menuItems = [
    {
      icon: "person",
      label: user?.first_name + " " + user?.last_name,
      title: user?.first_name + user?.last_name,
      variant: "info"
    },
    {
      icon: "mail",
      label: user?.email,
      title: user?.email,
      variant: "info"
    },
    {
      icon: "lock",
      label: "Change Password",
      onClick: onChangePassword,
      variant: "action"
    },
    {
      icon: "logout",
      label: "Log out",
      onClick: onLogout,
      variant: "danger"
    }
  ];

  return (
    <div className="profile-popover-container">
      {menuItems.map((item, index) => (
        <div key={index} title={item.title} onClick={item.onClick} className={`profile-menu-item ${item.variant}`}>
          <MaterialIcon name={item.icon} className="profile-menu-icon" />
          <span className={`profile-menu-label ${item.className || ""}`}>{item.label}</span>
        </div>
      ))}
    </div>
  );
};

export default ProfilePopover;
